export type LoginSchema = {
    username: string;
    password: string;
};

export const LOCAL_STORAGE_TOKEN = "huuskes-token";
